import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ModificaClienteComponent} from './modifica-cliente';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.modifica-cliente', {
            url: '/modifica-cliente',
            ncyBreadcrumb: {
              label: 'modifica-cliente',
              parent: 'home.scheda-clienti'
            },
            data: {
              authorisationLevel: 2,
              pageTitle: 'modifica-cliente'
            },
            'views': {
              'homeContent': {
                  template: '<modifica-cliente flex="100"></modifica-cliente>'
              }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ModificaClienteModule: string = ng
    .module('modifica-cliente', [
      'ui.bootstrap',
      uiRouter,
    ])
    .component('modificaCliente', ModificaClienteComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/scheda-clienti/modifica-cliente/modifica-cliente.module.ts